import { Component } from '@angular/core';
import { NavController, NavParams, InfiniteScroll } from 'ionic-angular';
import { ResultProvider } from '../../../providers/result/result';
import { LoaderProvider } from '../../../providers/loader/loader';
import { EventProvider } from '../../../providers/event/event';
import { TranslateService } from '@ngx-translate/core';

/**
 * Generated class for the ResoultRanglistPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */


@Component({
    selector: 'page-result-total',
    templateUrl: 'result-total.html',
})
export class ResultTotalPage {
    currentPage = 1;
    EVENTS_PER_PAGE = 25;

    eventType = "";
    eventArea = "";
    events = [];

    constructor(public navCtrl: NavController,
        public navParams: NavParams,
        public eventService: EventProvider,
        public resultService: ResultProvider,
        public loadingCtrl: LoaderProvider,
        public translate: TranslateService) {
        this.eventType = this.navParams.data.eventType;
        this.eventArea = this.navParams.data.events.category;
        this.events = Object.assign([], this.navParams.data.events.event);
    }

    arrayOf(n?: number) {
        return this.events.slice(0, this.EVENTS_PER_PAGE * this.currentPage);
    }

    loadNextPage(event: InfiniteScroll) {
        this.currentPage++;
        event.complete();
    }
}



// WEBPACK FOOTER //
// /src/pages/results/results-total/result-total.ts